import { render, staticRenderFns } from "./EditIconButton.vue?vue&type=template&id=338a75bb&scoped=true"
import script from "./EditIconButton.vue?vue&type=script&lang=js"
export * from "./EditIconButton.vue?vue&type=script&lang=js"
import style0 from "./EditIconButton.vue?vue&type=style&index=0&id=338a75bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338a75bb",
  null
  
)

export default component.exports